import React, { useState, useEffect } from 'react';
import { Form, Input, DatePicker, Button, Select } from 'antd';
import { ObtenerUsuarioByRole } from '../../../services/usuarios';
import { getGrupos } from '../../../services/grupos';

const { Option } = Select;

const SearchSection = ({ form, onSearch, onClear }) => {
  const [vendedores, setVendedores] = useState([]);
  const [loadingVendedores, setLoadingVendedores] = useState(false);
  const [grupos, setGrupos] = useState([]);
  const [loadingGrupos, setLoadingGrupos] = useState(false);

  useEffect(() => {
    const fetchVendedores = async () => {
      setLoadingVendedores(true);
      try {
        const response = await ObtenerUsuarioByRole(
          "vendedor rutas"
        );
        setVendedores(response);
      } catch (error) {
        console.error("Error fetching vendedores:", error);
      } finally {
        setLoadingVendedores(false);
      }
    };

    const fetchGrupos = async () => {
      setLoadingGrupos(true);
      try {
        const response = await getGrupos();
        setGrupos(response);
      } catch (error) {
        console.error("Error fetching grupos:", error);
      } finally {
        setLoadingGrupos(false);
      }
    };

    fetchVendedores();
    fetchGrupos();
  }, []);

  return (
    <Form
      form={form}
      layout="inline"
      onFinish={onSearch}
      style={{ marginBottom: 16 }}
    >
      <Form.Item name="consecutivo">
        <Input
          placeholder="Buscar por consecutivo"
          allowClear
          style={{ width: 200 }}
        />
      </Form.Item>

      <Form.Item name="vendedor">
        <Select
          placeholder="Seleccionar vendedor"
          allowClear
          style={{ width: 200 }}
          loading={loadingVendedores}
          showSearch
          filterOption={(input, option) =>
            (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
          }
        >
          {vendedores.map((vendedor) => (
            <Option key={vendedor.id} value={vendedor.id}>
              {`${vendedor.first_name} ${vendedor.last_name}`}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="fecha">
        <DatePicker
          placeholder="Seleccionar fecha"
          style={{ width: 200 }}
          format="DD/MM/YYYY"
        />
      </Form.Item>

      <Form.Item name="grupo">
        <Select
          placeholder="Seleccionar grupo de productos"
          allowClear
          style={{ width: 200 }}
          loading={loadingGrupos}
          showSearch
          filterOption={(input, option) =>
            (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
          }
        >
          {grupos.map((grupo) => (
            <Option key={grupo.id} value={grupo.id}>
              {grupo.nombre}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Buscar
        </Button>
        <Button style={{ marginLeft: 8 }} onClick={onClear}>
          Limpiar
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SearchSection;